export enum EditableMode {
  Read = "read",
  Write = "write",
}
